import React, {FC} from 'react';
import {Link} from 'react-router-dom';

import {NavItem, NavGroup} from './navData';

/**
 * 桌面端下拉菜单。展开/收起完全依赖 Tailwind 的 group-hover（CSS 级），
 * 与设计稿一致，不引入 JS 状态 —— 键盘用户可通过 Tab 聚焦内层链接触发 hover 语义。
 */

const renderItem = (item: NavItem) => {
  const content = (
    <>
      <div className={`w-8 h-8 rounded-md flex items-center justify-center ${item.iconBgClass}`}>
        <span className={item.iconColorClass}>{item.icon}</span>
      </div>
      <div>
        <div className="text-sm font-medium text-slate-900">{item.title}</div>
        <div className="text-xs text-slate-500">{item.description}</div>
      </div>
    </>
  );

  // 优先级：onClick（如合作申请）> to（站内）> href（站外）> 无落点占位
  if (item.onClick) {
    return (
      <button
        className="w-full text-left flex items-center gap-3 px-4 py-3 rounded-md hover:bg-slate-50 transition-colors"
        key={item.title}
        onClick={item.onClick}
        type="button"
      >
        {content}
      </button>
    );
  }
  if (item.to) {
    return (
      <Link
        className="flex items-center gap-3 px-4 py-3 rounded-md hover:bg-slate-50 transition-colors"
        key={item.title}
        to={item.to}
      >
        {content}
      </Link>
    );
  }
  if (item.href) {
    return (
      <a
        className="flex items-center gap-3 px-4 py-3 rounded-md hover:bg-slate-50 transition-colors"
        href={item.href}
        key={item.title}
        rel="noreferrer"
        target="_blank"
      >
        {content}
      </a>
    );
  }
  return (
    <button
      className="w-full text-left flex items-center gap-3 px-4 py-3 rounded-md hover:bg-slate-50 transition-colors cursor-default"
      key={item.title}
      type="button"
    >
      {content}
    </button>
  );
};

const NavDropdown: FC<{group: NavGroup}> = ({group}) => (
  <div className="relative group">
    <button
      className="nav-link text-sm text-slate-600 hover:text-slate-900 font-medium flex items-center gap-1 py-2"
      type="button"
    >
      {group.label}
      <svg
        className="w-3.5 h-3.5 transition-transform group-hover:rotate-180"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.5}
        viewBox="0 0 24 24"
      >
        <path d="M19 9l-7 7-7-7" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </button>
    <div className="absolute top-full left-0 mt-2 w-64 glass-card nav-dropdown-panel rounded-lg p-2 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 transform origin-top shadow-[0_10px_30px_rgba(0,0,0,0.08)]">
      {group.items.map(renderItem)}
    </div>
  </div>
);

export default NavDropdown;
